/* eslint-disable no-unused-vars */
import { IconButton, InputAdornment, Menu, MenuItem, Tooltip, } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import FindReplaceOutlinedIcon from '@material-ui/icons/FindReplaceOutlined';
import React, { useState } from 'react';
import { ButtonWrapper } from '../CampaignMainView.Styles';
import { CustomTextField, GridWrapper, TitleWrapper, Wrapper, } from './CampaignListTable.Styles';
import { Visibility } from '@material-ui/icons';
import { isBaseURLAll } from '../../../../api/utils';
import ReactAGGrid from '../../../commons/ReactAGGrid';
export var CampaignListTable = function (_a) {
    var onRowDoubleClick = _a.onRowDoubleClick, viewRow = _a.viewRow, deleteRow = _a.deleteRow, rowData = _a.rowData, openSidebar = _a.openSidebar;
    var _b = useState(null), filterAnchor = _b[0], setFilterAnchor = _b[1];
    var _c = useState('Campaign Name'), filterName = _c[0], setFilterName = _c[1];
    var _d = useState(''), filterTarget = _d[0], setFilterTarget = _d[1];
    var handleFilterMenu = function (event) {
        setFilterAnchor(event.currentTarget);
    };
    var handleCloseFilter = function () {
        setFilterAnchor(null);
    };
    var eventFilter = function (filterMode) {
        var lowerTarget = filterTarget.toLowerCase();
        switch (filterMode) {
            case 'Campaign Name':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a;
                    return ((_a = event === null || event === void 0 ? void 0 : event.CampaignName) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            case 'Task Queue':
                return rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (event) {
                    var _a, _b;
                    return (((_b = (_a = event === null || event === void 0 ? void 0 : event.BaseConfig) === null || _a === void 0 ? void 0 : _a.TaskQueue) === null || _b === void 0 ? void 0 : _b.toLowerCase().indexOf(lowerTarget)) !==
                        -1);
                });
            default:
                return rowData;
        }
    };
    var columns = [
        {
            headerName: 'Account Name',
            field: 'prjacc.name',
            hide: !isBaseURLAll(),
            width: 200
        },
        {
            field: 'CampaignName',
            headerName: 'Campaign Name',
            width: 200
        },
        {
            field: 'BaseConfig.CallingMode',
            headerName: 'Calling Mode',
            width: 200
        },
        {
            field: 'BaseConfig.CampaignGroupId',
            headerName: 'Group ID',
            hide: true,
            width: 225
        },
        {
            field: 'BaseConfig.TaskQueue',
            headerName: 'TaskQueue',
            width: 350
        },
        {
            field: 'BaseConfig.ContactListConfigID',
            headerName: 'Contact List ID',
            width: 200
        },
        {
            field: 'BaseConfig.Callerid',
            headerName: 'Default Caller ID',
            width: 200
        },
        {
            field: 'BaseConfig.StudioFlowOverride',
            headerName: 'Studio Flow Override',
            width: 350,
            cellRenderer: function (_a) {
                var _b, _c, _d;
                var rowData = _a.data;
                return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _b === void 0 ? void 0 : _b.StudioFlowOverride) !== '' &&
                    ((_c = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _c === void 0 ? void 0 : _c.StudioFlowOverride) != null
                    ? (_d = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _d === void 0 ? void 0 : _d.StudioFlowOverride : 'None';
            }
        },
        {
            field: 'BaseConfig.Weight',
            headerName: 'Campaign Priority',
            width: 200,
            cellRenderer: function (_a) {
                var _b, _c, _d;
                var rowData = _a.data;
                return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _b === void 0 ? void 0 : _b.Weight) !== '' &&
                    ((_c = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _c === void 0 ? void 0 : _c.Weight) != null
                    ? (_d = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _d === void 0 ? void 0 : _d.Weight : 'None';
            }
        },
        {
            field: 'BaseConfig.CPSToQueueSizeRatio',
            headerName: 'CPS to Queue Size Ratio',
            width: 200,
            cellRenderer: function (_a) {
                var _b, _c, _d;
                var rowData = _a.data;
                return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _b === void 0 ? void 0 : _b.CPSToQueueSizeRatio) !== '' &&
                    ((_c = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _c === void 0 ? void 0 : _c.CPSToQueueSizeRatio) != null
                    ? (_d = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _d === void 0 ? void 0 : _d.CPSToQueueSizeRatio : 'None';
            }
        },
        {
            field: 'BaseConfig.ActivePhoneTypes',
            headerName: 'Active Phone Types',
            width: 250,
            cellRenderer: function (_a) {
                var _b, _c;
                var rowData = _a.data;
                var outputString = (_c = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.BaseConfig) === null || _b === void 0 ? void 0 : _b.ActivePhoneTypes) === null || _c === void 0 ? void 0 : _c.toString().replaceAll(',', ', ');
                return outputString != null ? outputString : 'None';
            }
        },
        {
            field: 'Pacing.InitialCPAMode',
            headerName: 'Initial CPA Mode',
            width: 200
        },
        {
            field: 'Pacing.InitialCPA',
            headerName: 'Initial CPA',
            width: 200
        },
        {
            field: 'Pacing.MaxCPA',
            headerName: 'Max CPA',
            width: 200
        },
        {
            field: 'Pacing.InitialCPAMode',
            headerName: 'Initial CPA Mode',
            width: 250
        },
        {
            field: 'Pacing.InitialDuration',
            headerName: 'Initial Duration',
            width: 200
        },
        {
            field: 'Pacing.AbaIncrement',
            headerName: 'ABA Increment',
            width: 200,
            cellRenderer: function (_a) {
                var _b;
                var rowData = _a.data;
                return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing) === null || _b === void 0 ? void 0 : _b.AbaIncrement) + ' %';
            }
        },
        {
            field: 'Pacing.CpaModifier',
            headerName: 'CPA Modifier',
            width: 200,
            cellRenderer: function (_a) {
                var _b;
                var rowData = _a.data;
                return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing) === null || _b === void 0 ? void 0 : _b.CpaModifier) + ' %';
            }
        },
        {
            field: 'Pacing.AbaTargetRate',
            headerName: 'ABA Target Rate',
            width: 200,
            cellRenderer: function (_a) {
                var _b;
                var rowData = _a.data;
                return ((_b = rowData === null || rowData === void 0 ? void 0 : rowData.Pacing) === null || _b === void 0 ? void 0 : _b.AbaTargetRate) + ' %';
            }
        },
        {
            field: 'Pacing.AbaCalculation',
            headerName: 'ABA Calculation',
            width: 200
        },
        {
            field: 'Pacing.ConcurrentCalls',
            headerName: 'Max Concurrent Calls',
            width: 200
        },
        {
            field: 'CustomAttributes.ActiveAttributes',
            headerName: 'Custom Attributes',
            width: 250,
            cellRenderer: function (_a) {
                var _b, _c;
                var rowData = _a.data;
                var attrs = (_c = (_b = rowData === null || rowData === void 0 ? void 0 : rowData.CustomAttributes) === null || _b === void 0 ? void 0 : _b.ActiveAttributes) === null || _c === void 0 ? void 0 : _c.map(function (attr) { return attr === null || attr === void 0 ? void 0 : attr.Value; });
                var outputString;
                attrs === null || attrs === void 0 ? void 0 : attrs.forEach(function (attr, index) {
                    if (attr && attr !== undefined && index > 0) {
                        outputString += ", " + attr;
                    }
                    else if (attr && attr !== undefined) {
                        outputString = attr;
                    }
                    else {
                        outputString;
                    }
                });
                return outputString != null ? outputString : 'None';
            }
        },
    ];
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(ButtonWrapper, null,
                React.createElement(CustomTextField, { size: 'small', label: "Filter by " + filterName, placeholder: "Filter by " + filterName, variant: 'outlined', InputProps: {
                        endAdornment: (React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(Tooltip, { title: 'Change Filter Criteria', placement: 'top' },
                                React.createElement(IconButton, { onClick: handleFilterMenu },
                                    React.createElement(FilterListIcon, null)))))
                    }, onChange: function (e) { return setFilterTarget(e.target.value); } }),
                React.createElement(Menu, { id: 'filter-menu', open: Boolean(filterAnchor), keepMounted: true, anchorEl: filterAnchor, onClose: handleCloseFilter },
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Campaign Name');
                        } },
                        "Campaign Name",
                        ' '),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Task Queue');
                        } }, "Task Queue")))),
        React.createElement(GridWrapper, null,
            React.createElement(ReactAGGrid, { name: 'campaign', onRowClicked: function (e) { }, actions: [
                    {
                        icon: function () { return React.createElement(EditOutlinedIcon, null); },
                        tooltip: 'Edit',
                        disabled: openSidebar,
                        onClick: function (event, rowData) {
                            onRowDoubleClick(rowData, true);
                        }
                    },
                    {
                        icon: function () { return React.createElement(FindReplaceOutlinedIcon, null); },
                        tooltip: 'Copy',
                        disabled: openSidebar,
                        onClick: function (event, rowData) {
                            onRowDoubleClick(rowData, false);
                        }
                    },
                    {
                        icon: function () { return React.createElement(Visibility, null); },
                        tooltip: 'View',
                        disabled: openSidebar,
                        onClick: function (event, rowData) {
                            viewRow(rowData);
                        }
                    },
                    {
                        icon: function () { return React.createElement(DeleteOutlineOutlinedIcon, null); },
                        tooltip: 'Delete',
                        disabled: openSidebar,
                        onClick: function (event, rowData) {
                            deleteRow(rowData.id);
                        }
                    },
                ], columns: columns, rows: eventFilter(filterName), autoResize: true }))));
};
CampaignListTable.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CampaignListTable.js.map